import {makeEnvironmentProviders} from '@angular/core';
import {
  AbstractDocumentDialogsManagerService,
  AbstractEsslComponentDialogsManagerService,
  AbstractFileDialogsManagerService,
  AbstractFileSubjectRelationDialogsManagerService,
  AbstractManualPostDialogService,
  AbstractSharedFolderDialogsManagerService,
  AbstractStorageUnitDialogsManagerService,
  EsslComponentModalService
} from '|shared';
import {
  ManualPostDialogService
} from '|modules/office-desk/modules/office-desk-dialogs/components/manual-post-dialog/manual-post-dialog.service';
import {
  DocumentDialogsManagerService,
  FileDialogsManagerService,
  FileSubjectRelationDialogsManagerService,
  StorageUnitDialogsManagerService
} from '|feature-documents';
import {
  SharedFolderDialogsManagerService
} from '|modules/shared-folders/services/shared-folder-dialogs-manager.service';

export function provideDocumentDialogManagers() {
  return makeEnvironmentProviders([
    {
      provide: AbstractManualPostDialogService,
      useClass: ManualPostDialogService
    },
    {
      provide: AbstractFileDialogsManagerService,
      useClass: FileDialogsManagerService
    },
    {
      provide: AbstractFileSubjectRelationDialogsManagerService,
      useClass: FileSubjectRelationDialogsManagerService
    },
    {
      provide: AbstractDocumentDialogsManagerService,
      useClass: DocumentDialogsManagerService
    },
    {
      provide: AbstractStorageUnitDialogsManagerService,
      useClass: StorageUnitDialogsManagerService
    },
    {
      provide: AbstractSharedFolderDialogsManagerService,
      useClass: SharedFolderDialogsManagerService
    },
    {
      provide: AbstractEsslComponentDialogsManagerService,
      useClass: EsslComponentModalService
    },
  ]);
}
